import { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { Stage } from "../../../config/config";

export default function FrontOfPackage ({hasHighSatFat = false, hasHighSugars = false, hasHighSodium = false}) {

    const [label, setLabel] = useState();

    useEffect(() => {
        if(hasHighSatFat || hasHighSugars || hasHighSodium) {
            const stage = (Stage).toLowerCase();
            const stageSegment = (stage === 'dev' || stage === 'test') ? `.azr.${stage}` : '';
            const imageDomain = `https://nutrition-calculator${stageSegment}.tis.coke.com/static/media`;
            setLabel(`${imageDomain}/high${hasHighSatFat ? '1' : '0'}${hasHighSugars ? '1' : '0'}${hasHighSodium ? '1' : '0'}.png`)
        } else {
            setLabel(undefined)
        }
    }, [hasHighSatFat, hasHighSugars, hasHighSodium])

    return (
        <>
            {(hasHighSatFat || hasHighSugars || hasHighSodium) &&
                <>
                    <Typography>Front of Package: </Typography>
                    <Box id="front-of-package-label">
                        <img style={{marginBottom: '1em'}} src={label} alt="Front of Package Label"/>
                    </Box>
                </>
            }
        </>
    )
}